// Rejection reasons (backend RejectionReason) — a rejected file is unprocessable
// input, surfaced in the modal as "Rejected" rather than "Failed".
const REJECTION_CODES = new Set<string>(["UNSUPPORTED_FILE", "ENCRYPTED_PDF", "FILE_CONTENT_MISMATCH"]);

export const isRejectionCode = (errorCode: string | null | undefined): boolean =>
  !!errorCode && REJECTION_CODES.has(errorCode);

const ERROR_MESSAGES: Record<string, string> = {
  UNSUPPORTED_FILE: "This file was rejected — it's corrupted or in an unsupported format.",
  ENCRYPTED_PDF: "This file was rejected — the PDF is password-protected.",
  FILE_CONTENT_MISMATCH: "This file was rejected — its contents don't match the type its name claims.",
  DOCUMENT_PROCESSING_FAILED:
    "We couldn't process this file. It may be corrupted, password-protected, or in an unsupported format.",
  OCR_FAILED: "Document text extraction failed. The file may be corrupted or in an unsupported format.",
  VECTOR_INDEXING_FAILED: "Failed to index the document for search.",
  CONTRACT_FAMILY_GROUPING_FAILED: "Failed to group related contract documents.",
  SNAPSHOT_GENERATION_FAILED: "Snapshot generation failed. Please retry the snapshot.",
  INTERNAL_ERROR: "An unexpected error occurred. Please try again.",
};

export const getErrorMessage = (errorCode: string | null | undefined): string => {
  if (!errorCode) {
    return "An error occurred while processing this file.";
  }
  return ERROR_MESSAGES[errorCode] || `Processing failed: ${errorCode}`;
};
